import { INVOCATION_GRID2D__view } from '@shared/dto/generation/graph_invoke/_invocations/grid2d/INVOCATION_GRID2D__view';
import { INVOCATION__image_mask_boolean_to_tensor } from '@shared/dto/generation/graph_invoke/_invocations/image/INVOCATION__image_mask_boolean_to_tensor';
import { INVOCATION_IMAGE__create_mask_gradient } from '@shared/dto/generation/graph_invoke/_invocations/image/INVOCATION_IMAGE__create_mask_gradient';
import { INVOCATION__latents_blend } from '@shared/dto/generation/graph_invoke/_invocations/latents/INVOCATION__latents_blend';
import { INVOCATION_LATENTS__create_noise } from '@shared/dto/generation/graph_invoke/_invocations/latents/INVOCATION_LATENTS__create_noise';
import { INVOCATION_SD__denoise_latents_pipeline } from '@shared/dto/generation/graph_invoke/_invocations/sd/denoise/INVOCATION_SD__denoise_latents_pipeline';
import { INVOCATION_SD__text_encoder } from '@shared/dto/generation/graph_invoke/_invocations/sd/guidance/INVOCATION_SD__text_encoder';
import { INVOCATION_SD__latents_to_image } from '@shared/dto/generation/graph_invoke/_invocations/sd/vae/INVOCATION_SD__latents_to_image';
import { TYPE__class_constructor } from '@shared/types/TYPE__class_constructor';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { INVOCATION_IMAGE__color_map } from '../image/INVOCATION_IMAGE__color_map';
import { INVOCATION_IMAGE__scale } from '../image/INVOCATION_IMAGE__scale';
import { INVOCATION_IMAGE__viewport } from '../image/INVOCATION_IMAGE__viewport';
import { INVOCATION_SD__control_net } from '../sd/guidance/INVOCATION_SD__control_net';
import { INVOCATION_SD__ip_adapter } from '../sd/guidance/INVOCATION_SD__ip_adapter';
import { INVOCATION_SD__lora_select } from '../sd/guidance/INVOCATION_SD__lora_select';
import { INVOCATION_SD__t2i_adapter } from '../sd/guidance/INVOCATION_SD__t2i_adapter';
import { INVOCATION_SD__text_encoder_masked } from '../sd/guidance/INVOCATION_SD__text_encoder_masked';
import { INVOCATION_SD__image_to_latents } from '../sd/vae/INVOCATION_SD__image_to_latents';
import { INVOCATION_SPANDREL__upscaler } from '../spandrel/INVOCATION_SPANDREL__upscaler';
import { INVOCATION_SPANDREL__upscaler_to_side } from '../spandrel/INVOCATION_SPANDREL__upscaler_to_side';
import { INVOCATION_VISION_ML__depth_anything } from '../vision/depth/INVOCATION_VISION_ML__depth_anything';
import { INVOCATION_VISION_CV2__control_line_guidance_canny } from '../vision/line_guidance/canny/INVOCATION_VISION_CV2__control_line_guidance_canny';
import { INVOCATION_VISION_CV2__control_line_guidance_canny_auto } from '../vision/line_guidance/canny/INVOCATION_VISION_CV2__control_line_guidance_canny_auto';
import { INVOCATION_VISION_CV2__control_line_guidance_canny_semi_auto } from '../vision/line_guidance/canny/INVOCATION_VISION_CV2__control_line_guidance_canny_semi_auto';
import { INVOCATION_VISION_ML__control_line_guidance_hed } from '../vision/line_guidance/INVOCATION_VISION_ML__control_line_guidance_hed';
import { ENUM__invocation_type } from './ENUM__invocation_type';
import { FN_INVOCATION__create } from './FN_INVOCATION__create';
import { INVOCATION__base } from './INVOCATION__base';

export function FN_INVOCATION__create_manually_by_type<T extends INVOCATION__base>(type: ENUM__invocation_type, graph: DTO_GRAPH__instance): T {
  const out_map = new Map<ENUM__invocation_type, TYPE__class_constructor<INVOCATION__base>>([
    /*
     * SD
     */
    [ENUM__invocation_type.SD__DENOISE_LATENTS_PIPELINE, INVOCATION_SD__denoise_latents_pipeline],
    /*
     * SD VAE
     */
    [ENUM__invocation_type.SD__LATENTS_TO_IMAGE, INVOCATION_SD__latents_to_image],
    [ENUM__invocation_type.SD__IMAGE_TO_LATENTS, INVOCATION_SD__image_to_latents],
    /*
     * SD GUIDANCE
     */
    [ENUM__invocation_type.SD__TEXT_ENCODER, INVOCATION_SD__text_encoder],
    [ENUM__invocation_type.SD__TEXT_ENCODER_MASKED, INVOCATION_SD__text_encoder_masked],
    [ENUM__invocation_type.SD__LORA_SELECT, INVOCATION_SD__lora_select],
    [ENUM__invocation_type.SD__CONTROL_NET, INVOCATION_SD__control_net],
    [ENUM__invocation_type.SD__IP_ADAPTER, INVOCATION_SD__ip_adapter],
    [ENUM__invocation_type.SD__T2I_ADAPTER, INVOCATION_SD__t2i_adapter],
    [ENUM__invocation_type.LATENTS__CREATE_NOISE, INVOCATION_LATENTS__create_noise],

    /*
     * GRID2D
     */
    [ENUM__invocation_type.GRID2D__VIEW, INVOCATION_GRID2D__view],
    /*
     * IMAGE
     */
    //
    [ENUM__invocation_type.IMAGE__MASK_CREATE_GRADIENT, INVOCATION_IMAGE__create_mask_gradient],
    [ENUM__invocation_type.IMAGE__MASK_TO_TENSOR_IMAGE_MASK_BOOLEAN, INVOCATION__image_mask_boolean_to_tensor],
    [ENUM__invocation_type.IMAGE__VIEWPORT, INVOCATION_IMAGE__viewport],
    [ENUM__invocation_type.IMAGE__COLOR_MAP, INVOCATION_IMAGE__color_map],
    [ENUM__invocation_type.IMAGE__SCALE, INVOCATION_IMAGE__scale],

    /*
     *
     */
    [ENUM__invocation_type.SPANDREL__UPSCALER, INVOCATION_SPANDREL__upscaler],
    [ENUM__invocation_type.SPANDREL__UPSCALER_TO_SIDE, INVOCATION_SPANDREL__upscaler_to_side],

    /*
     * VISION
     */
    //
    [ENUM__invocation_type.VISION_CV2__LINE__CANNY, INVOCATION_VISION_CV2__control_line_guidance_canny],
    [ENUM__invocation_type.VISION_CV2__LINE__CANNY_AUTO, INVOCATION_VISION_CV2__control_line_guidance_canny_auto],
    [ENUM__invocation_type.VISION_CV2__LINE__CANNY_SEMI_AUTO, INVOCATION_VISION_CV2__control_line_guidance_canny_semi_auto],
    [ENUM__invocation_type.VISION_ML__LINE__HED, INVOCATION_VISION_ML__control_line_guidance_hed],
    //
    [ENUM__invocation_type.VISION_ML__DEPTH_ANYTHING, INVOCATION_VISION_ML__depth_anything],

    /*
     * LATENTS
     */
    //
    [ENUM__invocation_type.LATENTS_BLEND, INVOCATION__latents_blend],
  ]);

  const out_class = out_map.get_or_assert(type);

  let out = FN_INVOCATION__create(out_class, graph);

  out.fields__clear_roles();

  out.edges__try_autocreate(graph);

  return out as T;
}
